var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"re-group-box"},[(!!_vm.$slots['title'])?_c('div',{staticClass:"re-group-box-title-container"},[_c('h2',{staticClass:"re-group-box-title"},[_vm._t("title")],2)]):_vm._e(),_c('div',{staticClass:"re-group-box-content-container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }